// client/src/pages/adminpages/OngoingProjectPage.js
import React from 'react';
import AdminLayout from '../../components/admin/layout/AdminLayout';
import OngoingProjectList from '../../components/admin/project/OngoingProjectList';

function OngoingProjectPage() {
  return (
    <AdminLayout title="진행중인 프로젝트 보기">
      <div style={{ height: 'calc(100vh - 240px)', overflow: 'hidden' }}>
        <OngoingProjectList />
      </div>
    </AdminLayout>
  );
}

export default OngoingProjectPage;
